export interface Work {
  id: number;
  title: string;
  type: '电影' | '电视剧';
  year: number;
  role: string;
  director: string;
  cast: string[];
  tags: string[];
  popularity: number;
  cover: string;
  intro: string;
  description: string;
}

export const works: Work[] = [
  {
    id: 1,
    title: '东京暮色',
    type: '电影',
    year: 2019,
    role: '佐藤美咲',
    director: '中村和彦',
    cast: ['小仓优子', '白石隼也', '野村真理子'],
    tags: ['剧情', '都市', '成长'],
    popularity: 96,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20an%20elegant%20young%20East%20Asian%20woman%20in%20a%20warm%20camel%20coat%20standing%20alone%20on%20a%20quiet%20Tokyo%20street%20at%20dusk%20with%20soft%20amber%20city%20lights%20blurred%20behind%2C%20deep%20wine%20red%20and%20muted%20gold%20color%20tone%2C%20editorial%20film%20poster%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=600&height=800&seq=ogura-work-01&orientation=portrait',
    intro: '一部关于告别与重逢的都市剧情片，小仓优子饰演在东京独自打拼的摄影师。',
    description: '《东京暮色》讲述了一位年轻摄影师佐藤美咲在东京街头的独行故事。她在一次偶然的拍摄中重遇多年未见的旧友，被迫直面自己一直逃避的过往。小仓优子以细腻克制的表演，将角色的孤独、坚韧与温柔层层递进，成为影片最动人的部分。影片以温暖而略带忧郁的色调，勾勒出都市人内心深处的柔软角落，上映后获得观众与影评人的一致好评。',
  },
  {
    id: 2,
    title: '无声的证词',
    type: '电视剧',
    year: 2021,
    role: '小林凛',
    director: '山田健一',
    cast: ['小仓优子', '高桥凉介', '森田亚美'],
    tags: ['悬疑', '律政', '剧情'],
    popularity: 92,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20elegant%20young%20East%20Asian%20woman%20wearing%20a%20sharp%20dark%20tailored%20suit%20in%20a%20dim%20courtroom%20hallway%20with%20dramatic%20side%20lighting%20and%20deep%20shadows%2C%20wine%20red%20and%20charcoal%20color%20palette%2C%20serious%20confident%20expression%2C%20prestige%20drama%20TV%20poster%20aesthetic%2C%20high%20detail&width=600&height=800&seq=ogura-work-02&orientation=portrait',
    intro: '律政悬疑剧，小仓优子饰演一位执着追查真相的公诉检察官。',
    description: '在《无声的证词》中，小仓优子饰演公诉检察官小林凛。她接手了一桩看似证据确凿却疑点重重的旧案，在层层迷雾中抽丝剥茧。面对来自各方的压力，她始终坚持对司法正义的信念。剧集节奏紧凑，悬念环环相扣，小仓优子塑造的冷静而富有同理心的检察官形象深入人心，被视为其转型之作。',
  },
  {
    id: 3,
    title: '海边的信',
    type: '电影',
    year: 2020,
    role: '田中海音',
    director: '川岛直美',
    cast: ['小仓优子', '冈田将辉', '佐佐木玲'],
    tags: ['爱情', '治愈', '文艺'],
    popularity: 88,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20gentle%20young%20East%20Asian%20woman%20in%20a%20flowing%20white%20linen%20dress%20standing%20on%20a%20calm%20seaside%20pier%20at%20golden%20hour%2C%20soft%20warm%20sunlight%20and%20gentle%20sea%20breeze%2C%20pale%20gold%20and%20cream%20color%20tone%2C%20romantic%20literary%20film%20poster%20aesthetic%2C%20dreamy%20soft%20focus%2C%20high%20detail&width=600&height=800&seq=ogura-work-03&orientation=portrait',
    intro: '治愈系爱情电影，讲述一封跨越十年的信串联起的两段人生。',
    description: '《海边的信》以小仓优子饰演的田中海音为视角，讲述她在家乡海边小镇整理祖母遗物时，发现一叠从未寄出的信件。循着信中的线索，她重新认识了自己与这片海、与故人之间的羁绊。影片画面清新唯美，情感真挚细腻，小仓优子的表演温柔而有力量，被誉为当年最治愈的爱情电影之一。',
  },
  {
    id: 4,
    title: '京都四季',
    type: '电视剧',
    year: 2018,
    role: '藤原千鹤',
    director: '大野圭介',
    cast: ['小仓优子', '北村和也', '中谷美纪'],
    tags: ['家庭', '生活', '温情'],
    popularity: 84,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20elegant%20young%20East%20Asian%20woman%20wearing%20a%20refined%20kimono%20standing%20in%20a%20traditional%20Kyoto%20garden%20with%20maple%20leaves%20and%20stone%20path%2C%20soft%20autumn%20light%2C%20muted%20terracotta%20and%20gold%20tones%2C%20warm%20family%20drama%20poster%20aesthetic%2C%20tranquil%20atmosphere%2C%20high%20detail&width=600&height=800&seq=ogura-work-04&orientation=portrait',
    intro: '温情家庭剧，记录一位和服设计师在京都四季流转中的生活点滴。',
    description: '《京都四季》以小仓优子饰演的和服设计师藤原千鹤为主线，描绘她在传承家族手艺与现代生活之间的抉择。剧集以春樱、夏祭、秋枫、冬雪四章展开，节奏舒缓，充满生活气息。小仓优子将手艺人那份沉静与执着演绎得恰到好处，令观众感受到传统之美的动人力量。',
  },
  {
    id: 5,
    title: '午夜列车',
    type: '电影',
    year: 2022,
    role: '雨宫纱织',
    director: '中村和彦',
    cast: ['小仓优子', '松本润一', '宫崎葵'],
    tags: ['悬疑', '惊悚', '剧情'],
    popularity: 90,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20thriller%20poster%20of%20a%20mysterious%20young%20East%20Asian%20woman%20in%20a%20dark%20trench%20coat%20standing%20in%20the%20lit%20corridor%20of%20a%20night%20train%20with%20flickering%20amber%20lights%20and%20deep%20shadows%2C%20teal%20and%20wine%20red%20color%20tone%2C%20tense%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20high%20detail&width=600&height=800&seq=ogura-work-05&orientation=portrait',
    intro: '列车悬疑电影，一趟午夜班次揭开了深藏多年的秘密。',
    description: '《午夜列车》中，小仓优子饰演的雨宫纱织登上一趟深夜列车，却意外卷入一场扑朔迷离的事件。随着列车驶入无人的山谷，车厢内的乘客各怀心事，真相在对话与回忆中逐渐浮现。影片叙事结构精巧，氛围营造出色，小仓优子在有限空间内的情绪张力令人屏息，是近年少见的悬疑佳作。',
  },
  {
    id: 6,
    title: '我的料理日记',
    type: '电视剧',
    year: 2020,
    role: '安藤由佳',
    director: '铃木早苗',
    cast: ['小仓优子', '玉木宏太', '石原里美'],
    tags: ['美食', '治愈', '轻喜剧'],
    popularity: 80,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20cheerful%20young%20East%20Asian%20woman%20cooking%20in%20a%20cozy%20sunlit%20kitchen%20with%20fresh%20ingredients%20and%20steam%2C%20warm%20golden%20morning%20light%2C%20cream%20and%20soft%20terracotta%20color%20tone%2C%20food%20drama%20poster%20aesthetic%2C%20inviting%20homely%20atmosphere%2C%20high%20detail&width=600&height=800&seq=ogura-work-06&orientation=portrait',
    intro: '美食治愈剧，一位料理新人在日记中记录生活与成长的味道。',
    description: '《我的料理日记》讲述小仓优子饰演的安藤由佳从一名料理小白逐步成长为独当一面的主厨。她把自己每天的心得写在料理日记里，也用一道道菜安慰着身边的人。剧集暖胃又暖心，小仓优子的表演轻松自然，让观众在烟火气中收获最简单的感动。',
  },
  {
    id: 7,
    title: '樱之约',
    type: '电影',
    year: 2017,
    role: '新井沙耶',
    director: '川岛直美',
    cast: ['小仓优子', '三浦春马', '有村架纯'],
    tags: ['青春', '爱情', '校园'],
    popularity: 78,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20youth%20romance%20poster%20of%20a%20sweet%20young%20East%20Asian%20woman%20in%20a%20school%20uniform%20standing%20under%20blooming%20cherry%20blossom%20trees%20with%20soft%20pink%20petals%20falling%2C%20bright%20spring%20daylight%2C%20pale%20pink%20and%20cream%20color%20tone%2C%20nostalgic%20soft%20focus%2C%20high%20detail&width=600&height=800&seq=ogura-work-07&orientation=portrait',
    intro: '青春校园爱情片，樱花树下的约定跨越了整个青春。',
    description: '《樱之约》回到小仓优子塑造的青春年代，她饰演的新井沙耶与同伴在毕业前立下约定。多年后，当樱花再度盛开，那些未说出口的心事与遗憾终于有了归宿。影片清新明亮，情感真挚，唤起了无数观众对校园时光的共鸣，也是小仓优子早期代表作之一。',
  },
  {
    id: 8,
    title: '沉默的证人',
    type: '电视剧',
    year: 2023,
    role: '青山遥',
    director: '山田健一',
    cast: ['小仓优子', '藤木直人', '菜菜绪'],
    tags: ['刑侦', '悬疑', '剧情'],
    popularity: 94,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%20of%20a%20focused%20young%20East%20Asian%20woman%20detective%20in%20a%20dark%20blue%20raincoat%20examining%20a%20crime%20scene%20with%20police%20tape%2C%20moody%20cold%20lighting%20with%20warm%20highlights%2C%20wine%20red%20and%20slate%20color%20tone%2C%20tense%20investigative%20atmosphere%2C%20high%20detail&width=600&height=800&seq=ogura-work-08&orientation=portrait',
    intro: '刑侦悬疑剧，一位女法医以专业与直觉还原沉默的真相。',
    description: '《沉默的证人》中，小仓优子挑战法医角色青山遥。她凭借过硬的专业知识和敏锐的直觉，从细微的痕迹中读出死者最后的讯息。剧集案件构思扎实，人物塑造立体，小仓优子冷静理性的演绎为角色注入了独特的说服力，收获广泛好评。',
  },
  {
    id: 9,
    title: '雪国来信',
    type: '电影',
    year: 2021,
    role: '渡边冬子',
    director: '大野圭介',
    cast: ['小仓优子', '渡边谦吾', '广濑铃'],
    tags: ['文艺', '剧情', '温情'],
    popularity: 82,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20literary%20poster%20of%20a%20serene%20young%20East%20Asian%20woman%20in%20a%20thick%20cream%20wool%20coat%20standing%20in%20a%20quiet%20snowy%20village%20with%20falling%20snowflakes%20and%20wooden%20houses%2C%20soft%20overcast%20light%2C%20white%20pale%20gold%20and%20cool%20grey%20color%20tone%2C%20tranquil%20melancholic%20mood%2C%20high%20detail&width=600&height=800&seq=ogura-work-09&orientation=portrait',
    intro: '文艺剧情片，在北国的雪夜里，一封信温暖了整个寒冬。',
    description: '《雪国来信》讲述小仓优子饰演的渡边冬子在丈夫离世后回到北方故乡，独自面对凛冬与回忆。她在整理旧物时读到一封封来信，重新理解了那段被她误解的往事。影片构图极简，留白讲究，小仓优子内敛而克制的表演令人动容，是一部值得细品的文艺之作。',
  },
  {
    id: 10,
    title: '深夜食堂物语',
    type: '电视剧',
    year: 2019,
    role: '森川静香',
    director: '铃木早苗',
    cast: ['小仓优子', '小林薰', '松重丰'],
    tags: ['美食', '群像', '治愈'],
    popularity: 86,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20warm%20young%20East%20Asian%20woman%20proprietress%20standing%20at%20the%20counter%20of%20a%20small%20cozy%20late%20night%20diner%20with%20warm%20lantern%20light%2C%20wooden%20interior%2C%20golden%20amber%20and%20deep%20brown%20color%20tone%2C%20intimate%20healing%20atmosphere%2C%20high%20detail&width=600&height=800&seq=ogura-work-10&orientation=portrait',
    intro: '深夜食堂群像剧，深夜里的小店收留每一个疲惫的灵魂。',
    description: '《深夜食堂物语》以一家只在深夜营业的小食堂为中心，小仓优子饰演的森川静香是这里的主人。她不多言语，却用一碗碗热汤饭菜抚慰来往的客人。剧集由一个个温暖的小故事组成，市井烟火中透着人情温度，小仓优子的演出让这家小店格外令人留恋。',
  },
  {
    id: 11,
    title: '逆光飞翔',
    type: '电影',
    year: 2023,
    role: '宫本薰',
    director: '中村和彦',
    cast: ['小仓优子', '山崎贤人', '土屋太凤'],
    tags: ['励志', '剧情', '运动'],
    popularity: 91,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20inspiring%20poster%20of%20a%20determined%20young%20East%20Asian%20woman%20athlete%20in%20sportswear%20standing%20in%20a%20sunlit%20stadium%20with%20warm%20backlight%20and%20lens%20flare%2C%20energetic%20atmosphere%2C%20orange%20gold%20and%20wine%20red%20color%20tone%2C%20hopeful%20uplifting%20mood%2C%20high%20detail&width=600&height=800&seq=ogura-work-11&orientation=portrait',
    intro: '励志运动电影，一位运动员在低谷中逆光重生的故事。',
    description: '《逆光飞翔》讲述小仓优子饰演的田径选手宫本薰在重伤后艰难复出的历程。面对质疑与身体的极限，她选择重新站上起跑线。影片充满力量与热血，小仓优子为角色进行大量体能训练，真挚的表演传递出不服输的精神，激励了众多观众。',
  },
  {
    id: 12,
    title: '花见小路',
    type: '电视剧',
    year: 2022,
    role: '绫濑桃',
    director: '川岛直美',
    cast: ['小仓优子', '坂口健太郎', '波瑠'],
    tags: ['爱情', '生活', '都市'],
    popularity: 83,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20romantic%20poster%20of%20a%20graceful%20young%20East%20Asian%20woman%20in%20a%20light%20summer%20dress%20walking%20along%20a%20traditional%20stone%20alley%20lined%20with%20lanterns%20at%20dusk%2C%20warm%20golden%20glow%20and%20soft%20bokeh%2C%20rose%20and%20gold%20color%20tone%2C%20romantic%20urban%20drama%20aesthetic%2C%20high%20detail&width=600&height=800&seq=ogura-work-12&orientation=portrait',
    intro: '都市爱情剧，一条老街上相遇的两个人，彼此照亮了生活。',
    description: '《花见小路》中，小仓优子饰演在老街经营花店的绫濑桃。她与偶然来此的异乡人从误会到相知，共同守护这条承载回忆的小路。剧集画面唯美，对白细腻，小仓优子将都市女性的独立与温柔拿捏得恰到好处，让这段夏日之恋格外动人。',
  },
  {
    id: 13,
    title: '父亲的相机',
    type: '电影',
    year: 2018,
    role: '高桥奈绪',
    director: '大野圭介',
    cast: ['小仓优子', '役所广司', '满岛光'],
    tags: ['家庭', '剧情', '温情'],
    popularity: 79,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20of%20a%20tender%20young%20East%20Asian%20woman%20holding%20a%20vintage%20film%20camera%20in%20a%20warm%20old%20study%20filled%20with%20photo%20albums%20and%20soft%20afternoon%20light%2C%20golden%20amber%20and%20deep%20brown%20color%20tone%2C%20nostalgic%20emotional%20mood%2C%20high%20detail&width=600&height=800&seq=ogura-work-13&orientation=portrait',
    intro: '家庭温情片，一台老相机藏着一个家庭二十年的记忆。',
    description: '《父亲的相机》以小仓优子饰演的高桥奈绪为线索人物。父亲去世后，她整理出一台陪伴全家多年的老相机，冲洗出的每一张照片都是一段被遗忘的时光。影片以影像串联亲情，情感层层递进，小仓优子质朴真挚的表演直击人心，看哭无数观众。',
  },
  {
    id: 14,
    title: '星夜之约',
    type: '电影',
    year: 2024,
    role: '神谷诗织',
    director: '山田健一',
    cast: ['小仓优子', '横滨流星', '今田美樱'],
    tags: ['爱情', '奇幻', '剧情'],
    popularity: 95,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20romance%20poster%20of%20a%20dreamy%20young%20East%20Asian%20woman%20in%20a%20long%20coat%20standing%20on%20a%20hilltop%20under%20a%20vast%20starry%20night%20sky%20with%20the%20milky%20way%2C%20deep%20wine%20red%20and%20golden%20starlight%20color%20tone%2C%20romantic%20magical%20atmosphere%2C%20soft%20glow%2C%20high%20detail&width=600&height=800&seq=ogura-work-14&orientation=portrait',
    intro: '奇幻爱情新作，一场跨越星夜的约定在两颗心之间悄然兑现。',
    description: '《星夜之约》是小仓优子最新主演的奇幻爱情电影。她饰演的神谷诗织每逢星空之夜便会回到过去的一段时光，与以为早已失去的人重逢。影片以浪漫的想象力探讨遗憾与珍惜，画面美轮美奂，小仓优子的表演细腻动人，上映后引发热烈讨论。',
  },
];